import { render, staticRenderFns } from "./RecycleDisposedItemShowDialog.vue?vue&type=template&id=45970cc6&scoped=true&"
import script from "./RecycleDisposedItemShowDialog.vue?vue&type=script&lang=js&"
export * from "./RecycleDisposedItemShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45970cc6",
  null
  
)

export default component.exports